import Base from '@studiometa/js-toolkit';

/**
 * AxeptioLink
 */
export default class AxeptioLink extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'AxeptioLink',
    };
  }

  /**
   * Open cookie panel
   * @return {boolean} prevent url redirection
   */
  onClick(e) {
    e.preventDefault();
    window.openAxeptioCookies();
    return false;
  }
}
